export type DeviceIdentificationState = "identifying" | "ok" | "blocked";

/**
 * Traduz o retorno bruto do `useVisitorData` num estado de domínio.
 * `error` tem precedência: adblock / ITP do Safari derrubam o carregamento
 * do agente e isso vira `error`, então qualquer erro = device não verificável.
 */
export function getDeviceIdentificationState(input: {
  visitorId: string | null | undefined;
  error: unknown;
  isLoading: boolean;
}): DeviceIdentificationState {
  if (input.error) return "blocked";
  if (input.visitorId) return "ok";
  if (input.isLoading) return "identifying";
  return "blocked";
}

/**
 * Kill-switch. Default = enforce (true). Setar
 * NEXT_PUBLIC_ENFORCE_DEVICE_ID_AT_LOGIN="false" desliga o gate (fail-open),
 * usado se a FingerprintJS tiver uma queda global pra não travar todo mundo.
 */
export function isLoginDeviceGateEnabled(): boolean {
  return process.env.NEXT_PUBLIC_ENFORCE_DEVICE_ID_AT_LOGIN !== "false";
}
